import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import "./homeStyle.scss";
import AppImage from '../../common/features/image';
import AppCTA from '../../common/features/cta';
import { SectionWrapper } from '../../theme/layouts/MainLayout';
import { altLtGray, techBlack } from '../../common/utils/constant';
import { NavLink } from 'react-router-dom'
import HeroSection from './components/HeroSection';

function HomePage() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const EllipseImg = '/images/common/icons/bullet.png';

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <HeroSection />
      <SectionWrapper bg={altLtGray}>
        <section className='home-section2'>
          <Row className='home-section2-row'>
            <Col md={7} className='order-1 order-md-1'>
              <AppImage src={isMobile ? '/images/home/home_relationships_image_mobile.png' : '/images/home/home_relationships_image.png'} alt='img' className='img-section' />
            </Col>
            <Col md={5} className='order-2 order-md-2 home-section2-col'>
              <div className='title-section'>Relationship-based advertising that amplifies <span className='energy-purple'>results.</span></div>
              <div className='text-section'>As the No. 1 consumer tech specialty retailer in the U.S., customers look to us for support, guidance and inspiration more than 45 million times a week. With Best Buy Ads, your message reaches more potential customers in more meaningful ways for results that go beyond the imagination.</div>
            </Col>
          </Row>
          <Row className='home-section3-row'>
            <Col md={5} sm={12} className='order-2 order-md-1 home-section3-col'>
              <div className='title-section-2'>Unreal tracking <span className='energy-purple'>insights</span> in real time.</div>
              <div className='text-section-2'>Our network of partners, platforms and channels gives you access to billions of data points for an unparalleled understanding of every CE customer interaction so you can optimize campaigns in real time.</div>
              <div className='link-lets-talk'>
                <AppCTA.WithEnergyPurple title="Let's get started" url="lets-talk" width={24} height={24} alt='link' />
              </div>
            </Col>
            <Col md={7} sm={12} className='order-1 order-md-2'>
              <AppImage src={isMobile ? '/images/home/home_insights_graphic_mobile.svg' : '/images/home/home_insights_graphic.svg'} alt='img' className='img-section1' />
            </Col>
          </Row>
        </section>
      </SectionWrapper>

        <section className='audience-section-wrapper'>
        <SectionWrapper>
          <Row className='justify-content-md-between audience-content'>
            <Col md={6} sm={12} className='audience-left-title'>
              <h2 className='home-heading'>Our audience is into <span className='energy-purple'>everything.</span></h2>
            </Col>

            <Col md={6} sm={12} className='audience-right-content'>
              <div className='home-right-content'>
                With over 45 million interactions a week, we gather billions of data points on a broad range of actions and interests. Chances are your people are our people.
              </div>
              <div className='pt-4 home-cta-section'>
                <NavLink to="audience" className="cta-link-purple">
                  <div className='d-flex-home'> Learn more about our customer<br /> relationships <span className='link-space-home'><i className="bi bi-arrow-right"></i></span></div>
                </NavLink>
               
              </div>
            </Col>
          </Row>
          </SectionWrapper>

        <Row className='bg-home-graphic-img'>
          <Col md={12} className="background-home-graphic-img" onContextMenu={(e) => e.preventDefault()}>
          </Col>
        </Row>

        </section>
      


      <SectionWrapper bg={techBlack}>
       
        <section className='promo-section'>
          <Row>
            <Col md={6} xs={12} className="d-flex justify-content-center align-items-center g-0">
              <AppImage src={'/images/home/home_360_graphic.svg'} alt="img" className="promo-img" />
            </Col>
            <Col md={6} xs={12} className='d-flex justify-content-md-end promo-text'>
              <div className="d-flex flex-column">
                <div className="promo-content">
                  <div className='home-right-content promo-title'>
                    Our always-on ad platforms, products and partnerships put you right where decisions are made every time, all the time. From consideration to purchase, your message is front and center when it matters most.
                  </div>
                  <AppCTA.WithWhiteHover title="Learn more about our solutions" url="/solutions" />
                </div>
                <div className='d-flex flex-column'>
                  <h2 className='promo-head-text'>Search Ads</h2>
                  <h2 className='promo-head-text'>Display Ads</h2>
                  <h2 className='promo-head-text'>Video Ads</h2>
                  <h2 className='promo-head-text'>Direct Ads</h2>
                  <h2 className='promo-head-text'>Social Ads</h2>
                  <h2 className='promo-head-text'>Community Ads</h2>
                </div>
              </div>
            </Col>
          </Row>
        </section>
      </SectionWrapper>
      <SectionWrapper bg={altLtGray}>
        <div className="home-sec-track">
          <div className="px-0 main-wrapper">
            <section className='track-wrapper'>
              <Row className='justify-content-md-between track-content'>
                <Col md={6} sm={12} className='track-wrapper-left'>
                  <h2 className='home-heading'><span className='energy-purple'>Outperform</span> in every moment with performance tracking.</h2>
                </Col>
                <Col md={6} sm={12} className='track-wrapper-right'>
                  <div className='home-right-content'>
                    Maximize every level of the funnel and turn consideration into brand loyalty with our first-party audience insights and a deeper level of customer engagement.
                  </div>
                  <div className='home-cta-text'>
                    <AppCTA.WithEnergyPurple title="See examples of real results" url="/success-story" />
                  </div>
                </Col>
              </Row>

              <Row md={12} sm={12} className='track-img'>
                <AppImage src={isMobile ? '/images/home/home_outperform_graphic_mobile.png' : '/images/home/home_outperform_graphic.png'} alt="img" />
              </Row>
            </section>
          </div>
        </div>
      </SectionWrapper>
      <SectionWrapper bg={altLtGray}>
      
        <section className='infographic-wrapper'>
          <Row className='infographic-title-section'>
            <Col md={5} sm={12}>
              <div className='head-wrapper'>
                <h2 className='heading-infograph'>Best Buy <span className='energy-purple'>owns</span><br /> consumer electronics.</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={8} sm={12} className=''>
              <div className="info-left-content">No. <span className='energy-purple'>1</span></div>
            </Col>
            <Col md={4} sm={12} className='right-content-infograph d-flex flex-column justify-content-center'>
              <div className='hyphen-img'><AppImage src={EllipseImg} alt="img" /></div>
              <div>No. 1 consumer tech specialty retailer in the US.</div>
            </Col>
          </Row>
          <Row>
            <Col md={8} sm={12} className=''>
              <div className="info-left-content">2B<span className='energy-purple'>+</span></div>
            </Col>
            <Col md={4} sm={12} className='right-content-infograph d-flex flex-column justify-content-center'>
              <div className='hyphen-img'><AppImage src={EllipseImg} alt="img" /></div>
              <div>2B+ online, in-store, and in-home customer interactions per year.</div>
            </Col>
          </Row>
          <Row>
            <Col md={8} sm={12} className=''>
              <div className="info-left-content">15,000<span className='energy-purple'>+</span></div>
            </Col>
            <Col md={4} sm={12} className='right-content-infograph d-flex flex-column justify-content-center'>
              <div className='hyphen-img'><AppImage src={EllipseImg} alt="img" /></div>
              <div>15,000+ unique attributes inform our customer understanding, segmenting, and targeting.</div>
            </Col>
          </Row>

          <Row>
            <Col md={8} sm={12} className=''>
              <div className="info-left-content">70<span className='energy-purple'>%</span></div>
            </Col>
            <Col md={4} sm={12} className='right-content-infograph d-flex flex-column justify-content-center'>
              <div className='hyphen-img'><AppImage src={EllipseImg} alt="img" /></div>
              <div>70% of the U.S. population lives within 10 miles of a Best Buy store.</div>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={12}>
              <div className="home-data-source-link">
                <div onClick={handleToggle} id="dataId" className='home-source-link with-black-hover'>
                  Data sources
                  {isOpen ? <img src={'/images/common/icons/cheveron-up-purple.png'} alt="Up Icon" title="Up Icon" width={24}/> : <img src={'/images/common/icons/cheveron-down-purple.png'} alt="Down Icon" title="Down Icon" width={24}/>}
                </div>

                <div className={`home-expand-text ${isOpen ? 'open-home' : 'close-home'}`}>
                  <p>Internal Best Buy data ’22-’23</p>
                </div>
              </div>
            </Col>
          </Row>
        </section>
      </SectionWrapper>
    </div>
  )
}

export default HomePage